import React from 'react';

function NotFound() {
    return <p>404 Page not found</p>;
}

export default NotFound;